import { isSafeNavigationUrl } from '@experiences/util';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { generatePath } from 'react-router';

import * as RouteNames from '../../common/constants/RouteNames';
import { accountLogicalName } from '../../store/selectors';

const useNavigateToHome = (accountNameOverride?: string) => {
    const currentAccountName = useSelector(accountLogicalName);

    return useCallback(() => {
        const accountName = accountNameOverride ?? currentAccountName;
        // generatePath percent-encodes the param; the guard blocks any residual unsafe URL
        const homePath = generatePath(RouteNames.Home, { accountName });
        if (isSafeNavigationUrl(homePath)) {
            window.location.href = homePath;
        }
    }, [ accountNameOverride, currentAccountName ]);
};

export default useNavigateToHome;
